(() => {
  const heroes = document.querySelectorAll('[data-echtools-werkzeuge-hero]');

  heroes.forEach((hero) => {
    const slide = hero.closest('.slideshow-slide-werkzeuge');
    const products = hero.querySelector('.echtools-werkzeuge-products');
    const cards = [...hero.querySelectorAll('.echtools-werkzeuge-product')];
    const controls = [...document.querySelectorAll(
      '.slideshow-slide-werkzeuge .echtools-werkzeuge-category, .slideshow-slide-werkzeuge .echtools-werkzeuge-marker'
    )];
    let pinnedFamily = null;
    let previewFamily = null;

    const render = () => {
      const family = previewFamily || pinnedFamily;
      slide.classList.toggle('echtools-werkzeuge-active', Boolean(family));
      products.classList.toggle('has-active', Boolean(family));
      cards.forEach((card) => card.classList.toggle('is-active', card.dataset.family === family));
      controls.forEach((control) => {
        control.classList.toggle('is-active', control.dataset.family === family);
        if (control.matches('button')) {
          control.setAttribute('aria-pressed', String(control.dataset.family === pinnedFamily));
        }
      });
    };

    const syncInteractionState = () => {
      const elements = [...cards, ...controls];
      const hovered = elements.find((element) => element.matches(':hover'));
      const focused = elements.find((element) => element === document.activeElement || element.contains(document.activeElement));
      previewFamily = hovered?.dataset.family || focused?.dataset.family || null;
      render();
    };
    const scheduleInteractionSync = () => window.requestAnimationFrame(syncInteractionState);
    const clearRestoredInteractionState = () => {
      pinnedFamily = null;
      previewFamily = null;
      const activeElement = document.activeElement;
      if (activeElement instanceof HTMLElement && hero.contains(activeElement)) activeElement.blur();
      render();
    };
    window.addEventListener('pageshow', (event) => {
      window.requestAnimationFrame(event.persisted ? clearRestoredInteractionState : syncInteractionState);
    });
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) scheduleInteractionSync();
    });

    [...cards, ...controls].forEach((element) => {
      element.addEventListener('pointerenter', () => {
        previewFamily = element.dataset.family;
        render();
      });
      element.addEventListener('pointerleave', () => {
        previewFamily = null;
        render();
      });
      element.addEventListener('focus', () => {
        previewFamily = element.dataset.family;
        render();
      });
      element.addEventListener('blur', () => {
        previewFamily = null;
        render();
      });
    });

    controls.filter((control) => control.matches('button')).forEach((control) => {
      control.addEventListener('click', () => {
        pinnedFamily = pinnedFamily === control.dataset.family ? null : control.dataset.family;
        render();
      });
    });

    slide.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        pinnedFamily = null;
        previewFamily = null;
        render();
      }
    });

    render();
  });
})();
